/* KEA Sticker Motion
 * - Parallax vertical + rotation au scroll
 * - rotation_animation: "none" | "constantly_rotate" | "rotate_when_scrolling"
 * - Optionnellement, direction via data-kea-parallax-direction="normal|reverse"
 * - Respecte prefers-reduced-motion
 */

(function () {
  if (window.__KEA_STICKER_JS_INIT__) return;
  window.__KEA_STICKER_JS_INIT__ = true;

  var prefersReduced =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (prefersReduced) {
    return;
  }

  var roots = Array.prototype.slice.call(document.querySelectorAll("[data-kea-sticker-root]"));
  if (!roots.length) return;

  var items = roots.map(function (root) {
    var dirAttr = root.getAttribute("data-kea-parallax-direction") || "normal";
    var dir = dirAttr === "reverse" ? -1 : 1;

    return {
      root: root,
      parallaxEl: root.querySelector(".kea-sticker__parallax-el"),
      rotateEl: root.querySelector(".kea-sticker__rotate-el"),
      parallaxSpeed: parseFloat(root.getAttribute("data-kea-parallax-speed") || "0") || 0,
      parallaxEnabled: root.getAttribute("data-kea-parallax-enabled") === "true",
      rotateMode: root.getAttribute("data-kea-rotate-mode") || "none", // none | constantly_rotate | rotate_when_scrolling
      baseRotate: parseFloat(root.getAttribute("data-kea-base-rotate") || "0") || 0,
      dir: dir,
      stopEnabled: root.getAttribute("data-kea-stop-enabled") === "true",
      startX: parseFloat(root.getAttribute("data-kea-start-x") || "0"),
      startY: parseFloat(root.getAttribute("data-kea-start-y") || "0"),
      stopX: parseFloat(root.getAttribute("data-kea-stop-x") || "0"),
      stopY: parseFloat(root.getAttribute("data-kea-stop-y") || "0"),
      hasReachedStop: false,
    };
  });

  var scrollY = window.scrollY || window.pageYOffset || 0;

  window.addEventListener(
    "scroll",
    function () {
      scrollY = window.scrollY || window.pageYOffset || 0;
    },
    { passive: true },
  );

  function update() {
    var vh = window.innerHeight || 800;
    var centerViewport = vh / 2;

    items.forEach(function (item) {
      var rect = item.root.getBoundingClientRect();
      var centerEl = rect.top + rect.height / 2;
      var progress = (centerEl - centerViewport) / centerViewport; // -1..1 approx

      // PARALLAX
      if (item.parallaxEl && item.parallaxEnabled) {
        var offset = -progress * item.parallaxSpeed * 60 * item.dir; // 60px amplitude
        item.parallaxEl.style.transform = "translate3d(0," + offset.toFixed(1) + "px,0)";
      }
      // PARALLAX avec position d'arrêt
      if (item.parallaxEl && item.parallaxEnabled) {
        var offset;

        if (item.dir === -1) {
          // Mode reverse : scroll down = sticker monte
          offset = scrollY * item.parallaxSpeed * 0.3;
        } else {
          // Mode normal
          offset = -progress * item.parallaxSpeed * 60;
        }

        // Si position d'arrêt activée
        if (item.stopEnabled && !item.hasReachedStop) {
          // Calculer le déplacement nécessaire de la position initiale à la position finale
          var deltaX = item.stopX - item.startX; // en %
          var deltaY = item.stopY - item.startY; // en %

          // Calculer la progression (0 à 1) basée sur le scroll
          // On peut utiliser scrollY ou progress selon le mode
          var progressToStop;
          if (item.dir === -1) {
            // En mode reverse, on utilise scrollY pour déterminer la progression
            // Définir une distance de scroll pour atteindre la position (ex: 500px)
            var scrollDistance = 800; // Distance en px à parcourir
            progressToStop = Math.min(scrollY / scrollDistance, 1);
          } else {
            // En mode normal, on utilise progress
            progressToStop = Math.min(Math.max((1 - progress) / 2, 0), 1);
          }

          // Calculer les nouvelles positions
          var currentX = item.startX + deltaX * progressToStop;
          var currentY = item.startY + deltaY * progressToStop;

          // Appliquer la position
          item.root.style.left = currentX + "%";
          item.root.style.top = currentY + "%";

          // Appliquer le parallax offset par-dessus
          item.parallaxEl.style.transform = "translate3d(0," + offset.toFixed(1) + "px,0)";

          // Vérifier si on a atteint la position finale
          if (progressToStop >= 1) {
            item.hasReachedStop = true;
            // Fixer la position finale
            item.root.style.left = item.stopX + "%";
            item.root.style.top = item.stopY + "%";
          }
        }

        // ROTATION
        if (item.rotateEl && item.rotateMode !== "none") {
          var rot = item.baseRotate;

          if (item.rotateMode === "constantly_rotate") {
            // rotation continue (ne dépend que du scrollY global)
            rot += (scrollY * item.parallaxSpeed * 0.2 * item.dir) % 360;
          } else if (item.rotateMode === "rotate_when_scrolling") {
            // balancement en fonction de la position par rapport au viewport
            rot += progress * item.parallaxSpeed * 40 * item.dir;
          }

          item.rotateEl.style.transform = "rotate(" + rot.toFixed(1) + "deg)";
        }
      }
    });

    requestAnimationFrame(update);
  }

  requestAnimationFrame(update);

  // Support Theme Editor: re-scan on section load/unload
  document.addEventListener("shopify:section:load", function (event) {
    var rootEls = event.target.querySelectorAll("[data-kea-sticker-root]");
    if (!rootEls.length) return;

    Array.prototype.forEach.call(rootEls, function (root) {
      var dirAttr = root.getAttribute("data-kea-parallax-direction") || "normal";
      var dir = dirAttr === "reverse" ? -1 : 1;

      items.push({
        root: root,
        parallaxEl: root.querySelector(".kea-sticker__parallax-el"),
        rotateEl: root.querySelector(".kea-sticker__rotate-el"),
        parallaxSpeed: parseFloat(root.getAttribute("data-kea-parallax-speed") || "0") || 0,
        parallaxEnabled: root.getAttribute("data-kea-parallax-enabled") === "true",
        rotateMode: root.getAttribute("data-kea-rotate-mode") || "none",
        baseRotate: parseFloat(root.getAttribute("data-kea-base-rotate") || "0") || 0,
        dir: dir,
      });
    });
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var rootEls = event.target.querySelectorAll("[data-kea-sticker-root]");
    if (!rootEls.length) return;

    items = items.filter(function (item) {
      return Array.prototype.indexOf.call(rootEls, item.root) === -1;
    });
  });
})();
